<template>
  <v-container fluid>
    <v-row justify="center" class="mt-n6 mx-1 mb-2">
      <v-icon class="mx-2" size="35px">receipt_long</v-icon>

      <span style="font-size: 34px; color: #616161">Rutas de aprobación</span>
    </v-row>
    <!-- LISTADO DE RUTAS -->
    <v-card class="mb-6" outlined>
      <v-card-title class="d-flex align-center">
        <span class="text-h6">Rutas de aprobación</span>
        <v-spacer />
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
          dense
          outlined
          clearable
          style="max-width: 300px"
        />
        <v-spacer />
        <v-btn color="primary" @click="openCreate">
          <v-icon left>mdi-plus</v-icon>
          Nueva ruta
        </v-btn>
      </v-card-title>

      <v-data-table :headers="workflowHeaders" :items="workflows" :search="search" item-key="id" dense>
        <template v-slot:item.status_id="{ item }">
          <v-chip small :color="item.status_id === 1 ? 'green' : 'grey'" dark>
            {{ item.status_id === 1 ? 'Activa' : 'Inactiva' }}
          </v-chip>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-menu bottom left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item @click="viewWorkflow(item)">
                <v-list-item-icon><v-icon>mdi-eye</v-icon></v-list-item-icon>
                <v-list-item-title>Ver ruta</v-list-item-title>
              </v-list-item>
              <v-list-item @click="editWorkflow(item)">
                <v-list-item-icon><v-icon>mdi-pencil</v-icon></v-list-item-icon>
                <v-list-item-title>Editar ruta</v-list-item-title>
              </v-list-item>
              <v-list-item @click="workflow_assignments(item)">
                <v-list-item-icon><v-icon>corporate_fare</v-icon></v-list-item-icon>
                <v-list-item-title>Plantas</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </v-card>

    <!-- DIALOGO CREAR / EDITAR / VER -->
    <v-dialog v-model="dialog" max-width="900px" persistent>
      <v-card>
        <v-card-title class="text-h6">
          {{ modeTitle }}
        </v-card-title>

        <v-card-text>
          <!-- DATOS GENERALES -->
          <v-form ref="form">
            <v-row align="center" justify="center">
              <v-col cols="8">
                <v-text-field label="Nombre de la ruta" v-model="form.name" :disabled="isView" required outlined dense
                  hide-details />
              </v-col>
              <v-col cols="4">
                <v-switch label="Activa" v-model="form.status_id" :true-value="1" :false-value="0" :disabled="isView" />
              </v-col>
            </v-row>
          </v-form>

          <!-- PASOS DE APROBACIÓN -->
          <v-divider class="my-4" />
          <div class="d-flex justify-space-between align-center mb-2">
            <span class="subtitle-1">Pasos de aprobación</span>
            <v-btn small outlined color="primary" @click="addStep" v-if="!isView">
              <v-icon left small>mdi-plus</v-icon>
              Agregar paso
            </v-btn>
          </div>

          <v-data-table :headers="stepsHeaders" :items="form.steps" item-key="_key" dense hide-default-footer>
            <template v-slot:item.level="{ index }">
              {{ index + 1 }}
            </template>
            <template v-slot:item.user="{ item }">
              <v-col md="12">
                <v-autocomplete v-model="item.user_id" :items="users" item-text="approbal" item-value="user_id" dense
                  outlined hide-details :disabled="isView" />
              </v-col>
            </template>

            <template v-slot:item.init_amount="{ item }">
              <v-text-field v-model.number="item.init_amount" type="number" dense disabled hide-details />
            </template>

            <template v-slot:item.limit_amount="{ item }">
              <v-text-field v-model.number="item.limit_amount" type="number" dense hide-details :disabled="isView" />
            </template>

            <template v-slot:item.actions="{ index }">
              <v-btn icon color="red" @click="removeStep(index)" v-if="!isView">
                <v-icon small>mdi-delete</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn text @click="close">Cerrar</v-btn>
          <v-btn color="primary" @click="save" outlined :loading="loading" v-if="!isView">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ASIGNACIÓN DE PLANTAS -->
    <v-dialog v-model="dialog_locations" width="60%" persistent>
      <v-card>
        <v-card-title class="text-h6">
          Locations para la ruta {{ route_name }}
        </v-card-title>
        <v-card-text>
          <DataIterator v-if="constAllLocations.length > 0" :all_items="constAllLocations"
            :items_selected="locationsSelecteds" :hide_footer="true" vh_height="40vh" :title="{
              all: 'Locations',
              selected: 'Locations seleccionadas',
            }" />
            <v-row align="center" justify="center">
              <v-col cols="4">
                <v-select
                  v-model="default_location_id"
                  :items="selectedLocationItems"
                  item-text="name"
                  item-value="id"
                  label="Location por defecto"
                  outlined
                  dense
                  clearable
                  hide-details
                  class="mt-4"
                  :disabled="locationsSelecteds.length === 0"
                />
              </v-col>
            </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialog_locations = false">Cerrar</v-btn>
          <v-btn color="primary" @click="save_locations" outlined :loading="loading">Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import DataIterator from "@/components/DataIterator";
export default {
  data() {
    return {
      search: '',
      workflows: [],
      constAllLocations: [],
      locationsSelecteds: [],
      route_name: null,
      workflow_id_locations: null,
      default_location_id: null,
      users: [],
      dialog: false,
      dialog_locations: false,
      loading: false,
      mode: 'create', // create | edit | view
      form: {
        id: null,
        name: '',
        status_id: 1,
        steps: []
      },
      workflowHeaders: [
        { text: 'ID', value: 'id', width: '80px' },
        { text: 'Nombre', value: 'name' },
        { text: 'Estado', value: 'status_id', width: '120px' },
        { text: 'Acciones', value: 'actions', sortable: false, width: '100px' }
      ],
      stepsHeaders: [
        { text: 'Nivel', value: 'level', sortable: false },
        { text: 'Aprobador', value: 'user' },
        { text: 'Monto inicial', value: 'init_amount', width: '150px', sortable: false },
        { text: 'Monto límite', value: 'limit_amount', width: '150px', sortable: false },
        { text: 'Acciones', value: 'actions', sortable: false, width: '80px', sortable: false }
      ]
    }
  },
  components: {
    DataIterator
  },
  computed: {
    isView() {
      return this.mode === 'view'
    },
    selectedLocationItems() {
      return this.locationsSelecteds.map(l => {
        const full = this.constAllLocations.find(loc => loc.id === (l.id ?? l));
        return full || { id: l.id ?? l, name: String(l.id ?? l) };
      });
    },
    modeTitle() {
      if (this.mode === 'create') return 'Nueva ruta de aprobación'
      if (this.mode === 'edit') return 'Editar ruta de aprobación'
      return 'Detalle de ruta de aprobación'
    }
  },
  mounted() {
    this.fetchWorkflows();
    this.fetchUsers();
    this.get_all_locations();
  },
  methods: {
    async get_all_locations() {
      try {
        const result = await this.api_Get("humanResource/locations");
        const data = await result.json();
        for (let item of data) {
          this.constAllLocations.push({
            name: `${item.desc_loc_short} - ${item.desc_loc_long}`,
            id: item.id,
            business_id: item.bus_id,
          });
        }
      } catch (error) {
        console.error("Error fetching locations:", error.message);
      }
    },
    async fetchWorkflows() {
      try {
        const data = await this.api_Get("shopping/approval_routes");
        this.workflows = await data.json();
      } catch (error) {
        console.error(error.message)
      }
    },
    async fetchUsers() {//buscar solo aprobadores
      const responseUsers = await this.api_Get("auth/user_approbals");
      this.users = await responseUsers.json();
    },
    openCreate() {
      this.mode = 'create'
      this.form = { id: null, name: '', status_id: 1, steps: [] }
      this.dialog = true
    },
    viewWorkflow(item) {
      this.loadWorkflow(item)
      this.mode = 'view'
      this.dialog = true
    },
    editWorkflow(item) {
      this.loadWorkflow(item)
      this.mode = 'edit'
      this.dialog = true
    },
    workflow_assignments(item) {
      this.route_name = item.name;
      this.workflow_id_locations = item.id;
      this.locationsSelecteds = item.approval_workflow_locations;
      this.default_location_id = item.default_location_id ?? null;
      this.dialog_locations = true;
    },
    async loadWorkflow(item) {
      // GET steps by workflow_id
      // const steps = await api...
      this.form = {
        id: item.id,
        name: item.name,
        status_id: item.status_id,
        steps: item.approval_workflow_steps
      }
    },
    addStep() {

      if (this.form.steps.length > 0 && this.form.steps[this.form.steps.length - 1].init_amount == this.form.steps[this.form.steps.length - 1].limit_amount) {
        this.$toast.warning("El monto inicial no puede ser igual al monto final!");
        return
      }

      if (this.form.steps.length > 0 && this.form.steps[this.form.steps.length - 1].limit_amount <= this.form.steps[this.form.steps.length - 1].init_amount) {
        this.$toast.warning("El monto final no puede ser igual o menor al monto inicial!");
        return
      }
      this.form.steps.push({
        _key: Date.now() + Math.random(),
        user_id: null,
        init_amount: this.form.steps.length == 0 ? 0 : this.form.steps[this.form.steps.length - 1].limit_amount + 1,
        limit_amount: 0
      })
    },
    removeStep(index) {
      this.form.steps.splice(index, 1)
    },
    async save() {
      const seenUserIds = new Set();
      for (let key in this.form.steps) {
        const currentUserId = this.form.steps[key].user_id;
        this.form.steps[key].level_id = parseInt(key) + 3;
        if (this.form.steps[key].user_id == null) {
          this.$toast.warning(`Debe indicar aprobador del nivel ${parseInt(key) + 1}!`);
          return
        }
        if (seenUserIds.has(currentUserId)) {
          this.$toast.warning(`El aprobador del nivel ${parseInt(key) + 1} ya ha sido asignado en un nivel anterior!`);
          return;
        }
        seenUserIds.add(currentUserId);
        if (key == 0) { continue; }
        if (this.form.steps[key].limit_amount <= this.form.steps[key].init_amount) {
          this.$toast.warning(`El monto final del aprobador de nivel ${parseInt(key) + 1} no puede ser igual o menor al monto inicial!`);
          return
        }
      }
      try {
        this.loading = true;

        if (this.mode === 'create') {
          this.form.id = null;
        }
        const responseRequest = await this.api_Post("shopping/add_or_update_approval_routes", {
          id: this.form.id,
          name: this.form.name,
          status_id: this.form.status_id,
          steps: this.form.steps
        });
        if (responseRequest.status == 200) {
          this.close()
          this.fetchWorkflows()
        }
      } catch (error) {
        console.error("Error searching clients:", error);
        this.$toast.error("Error de conexión!");
      } finally {
        this.loading = false;
      }
    },
    async save_locations() {
      try {
        this.loading = true;
        const payload = this.locationsSelecteds.map(l => {
          const full = this.constAllLocations.find(loc => loc.id === (l.id ?? l));
          return {
            location_id: full ? full.id : (l.id ?? l),
            business_id: full ? full.business_id : l.business_id
          };
        });
        const response = await this.api_Post("shopping/save_workflow_locations", {
          workflow_id: this.workflow_id_locations,
          locations: payload,
          default_location_id: this.default_location_id
        });
        if (response.status === 200) {
          this.$toast.success("Locations guardadas correctamente");
          this.dialog_locations = false;
          this.fetchWorkflows();
        } else {
          const err = await response.json();
          this.$toast.error(err.error || "Error al guardar las locations");
        }
      } catch (error) {
        console.error(error);
        this.$toast.error(error.message || "Error de conexión");
      } finally {
        this.loading = false;
      }
    },
    close() {
      this.dialog = false
    }
  }
}
</script>
